'use strict';

$(document).ready(function() {
	$('.contact__form').bootstrapValidator({
		message: 'This value is not valid',
		fields: {
			name: {
				message: 'The name is not valid',
				validators: {
					notEmpty: {
						message: 'Please fill in the required field.'
					}
				}
			},
			email: {
				validators: {
					notEmpty: {
						message: 'Please fill in the required field.'
					},
					emailAddress: {
						message: 'Email address seems invalid.'
					}
				}
			}
		},
	});
});